export interface Organization {
    org_id: string
    user_id: string
    name: string
    email: string
    contact_info: string
}

export interface OrganizationDTO {
    email: string
    organizationName: string
    contactInfo: string
}

export interface CurrentAccount {
    orgId: string
    userId: string
    email: string
    role: UserRole
}

export enum UserRole {
    superAdmin = 'superadmin',
    orgAdmin = 'org_admin',
}

export const mapOrganizationToDTO = (org: Organization): OrganizationDTO => ({
    email: org.email,
    organizationName: org.name,
    contactInfo: org.contact_info,
})

export const mapDTOToOrganization = (dto: OrganizationDTO, org_id: string, user_id: string): Organization => ({
    org_id,
    user_id,
    email: dto.email,
    name: dto.organizationName,
    contact_info: dto.contactInfo,
})
